import { createContext } from 'react';

export type TMSContextType = {
  tmsName: string;
  tmsID: number;
  tenant: string;
  isTestingEnvironment: boolean;
};

export const TMSContext = createContext<TMSContextType>({
  tmsName: '',
  tmsID: 0,
  tenant: '',
  isTestingEnvironment: false,
});
